/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanBarcodeClassicIcon20Regular = forwardRef('ScanBarcodeClassicIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.499 4.375a.75.75 0 0 0-1.5 0v11.25a.75.75 0 0 0 1.5 0V4.375Z" }),
        React.createElement("path", { d: "M5.65 3.625a.75.75 0 0 1 .75.75v9.321a.75.75 0 0 1-1.5 0V4.375a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M9.3 4.375a.75.75 0 0 0-1.5 0v9.321a.75.75 0 0 0 1.5 0V4.375Z" }),
        React.createElement("path", { d: "M11.45 3.625a.75.75 0 0 1 .75.75v11.25a.75.75 0 0 1-1.5 0V4.375a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M15.101 4.375a.75.75 0 0 0-1.5 0v9.321a.75.75 0 0 0 1.5 0V4.375Z" }),
        React.createElement("path", { d: "M18.002 4.375a.75.75 0 0 0-1.5 0v11.25a.75.75 0 0 0 1.5 0V4.375Z" })));
});
